import React from 'react';
import { connect } from 'react-redux';

import Banner from '../../components/Banner';
import { Button } from '@eb/eds-button';

import { Icon } from '@eb/eds-icon';
import { ChevronRightChunky as ChevronRightChunkySvg } from '@eb/eds-iconography';
import { getOnlineEventsOption } from '@eb/redux-destination';

import gettext from '@eb/gettext';
import { searchByBBoxOrPlace as searchByBBoxOrPlaceAction } from '../actions/search';
import { GA_SEARCH_CATEGORY, GA_CITY_BROWSE_CATEGORY } from '../constants';

import './OnlineEventsBannerContainer.scss';

const trackCTAOnlineEventsBanner = (isSearch, locationSlug) => ({
    type: 'TRACK_ONLINE_EVENTS_BANNER_CLICK',
    meta: {
        analytics: {
            category: isSearch ? GA_SEARCH_CATEGORY : GA_CITY_BROWSE_CATEGORY,
            action: 'OnlineEventsBannerClick',
            label: locationSlug,
        },
    },
});

// For search, location changing is integrated into the SPA experience
// (no full page load to get the new content)
// Browse does not have this set up, so we have to manually set the location.
const handleLocationSelectForBrowsePage = () => {
    if (typeof window === 'object') {
        window.location = '/d/online/events/';
    }
};

const OnlineEventsBanner = (props) => {
    const {
        locationSlug,
        handleLocationSelectForSearchPage,
        isSearch,
        handleTracking,
        shouldDirectLink,
    } = props;
    const shouldShowOnlineBanner = locationSlug && locationSlug !== 'online';

    if (!shouldShowOnlineBanner) {
        return null;
    }

    return (
        <div
            className={`online-events-banner ${
                props?.containerClassName || ''
            }`}
        >
            <Banner style="dark">
                <div
                    className="online-events-banner__text"
                    dangerouslySetInnerHTML={{
                        __html: gettext(
                            'Stay connected: Browse our online and virtual events',
                        ),
                    }}
                />
                <div className="online-events-banner__cta">
                    <Button
                        style="none"
                        onClick={() => {
                            handleTracking(isSearch, locationSlug);

                            shouldDirectLink
                                ? handleLocationSelectForBrowsePage()
                                : handleLocationSelectForSearchPage(
                                      getOnlineEventsOption(),
                                  );
                        }}
                    >
                        {gettext("Let's go")}
                        <Icon
                            type={<ChevronRightChunkySvg />}
                            color="ui-orange"
                        />
                    </Button>
                </div>
            </Banner>
        </div>
    );
};

const _mapStateToProps = ({ location, locationAndSearchInformation }) => ({
    locationSlug: location.slug,
    placeId: location.id,
    isSearch: !!Object.keys(locationAndSearchInformation).length,
});

const _mapDispatchToProps = (dispatch, ownProps) => ({
    handleLocationSelectForSearchPage: (...args) =>
        dispatch(searchByBBoxOrPlaceAction(ownProps.history, ...args)),
    handleTracking: (...args) => dispatch(trackCTAOnlineEventsBanner(...args)),
});

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(OnlineEventsBanner);
